import React, { useEffect, useState } from "react";
import { Trophy, Calendar } from "lucide-react";
import api from "@/lib/api";

export default function Contests() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/contests").then((r) => setItems(r.data)); }, []);
  return (
    <div className="space-y-8" data-testid="contests-page">
      <div>
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-amber-700">Win Big</span>
        <h1 className="font-display text-4xl lg:text-5xl font-black tracking-tight mt-2">Live Contests</h1>
        <p className="text-stone-600 mt-2">Compete with other partners and win exciting prizes.</p>
      </div>
      {items.length === 0 ? (
        <div className="bg-white rounded-2xl border border-stone-200 p-16 text-center text-stone-500">
          <Trophy className="w-10 h-10 mx-auto mb-3 opacity-40" />
          <p>No active contests right now. Check back soon!</p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((c) => (
            <div key={c.id} className="bg-white rounded-2xl border border-stone-200 overflow-hidden" data-testid={`contest-${c.id}`}>
              {c.image && <img src={c.image} alt={c.title} className="w-full h-44 object-cover" />}
              <div className="p-6">
                <div className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-amber-700 bg-amber-50 px-2 py-1 rounded-full">
                  <Trophy className="w-3 h-3" /> Prize · {c.prize}
                </div>
                <h3 className="font-display text-xl font-bold mt-3">{c.title}</h3>
                <p className="text-sm text-stone-600 mt-2 leading-relaxed">{c.description}</p>
                {(c.starts_at || c.ends_at) && (
                  <div className="mt-4 pt-4 border-t border-stone-100 flex items-center gap-1.5 text-xs text-stone-500">
                    <Calendar className="w-3 h-3" />
                    {c.starts_at && <span>From {new Date(c.starts_at).toLocaleDateString()}</span>}
                    {c.ends_at && <span>· Till {new Date(c.ends_at).toLocaleDateString()}</span>}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
